// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./StudentDash.css"; // Ensure correct styling

// const StudentDash = () => {
//   const [students, setStudents] = useState([]);
//   const [searchName, setSearchName] = useState("");
//   // const [searchLocation, setSearchLocation] = useState("");
//   const [searchYear, setSearchYear] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const studentsPerPage = 9;

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const { data } = await axios.get("http://localhost:5000/api/students");

//       // // ✅ Extract Graduation Year from Enrollment Number & Cloudinary Profile Image
//       // const updatedStudents = data
//       //   .filter(student => student.role === "student")
//       //   .map(student => ({
//       //     ...student,
//       //     graduationYear: `20${String(student.enrollmentNumber).slice(-2)}`,
//       //     profileImageUrl: student.profileImageUrl
//       //       ? student.profileImageUrl
//       //       : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//       //   }));

//   // ✅ Extract Graduation Year from Enrollment Number
//   const updatedStudents = data.data.map((student) => ({
//     ...student,
//     graduationYear: student.graduationYear || "N/A",
//     profileImageUrl: student.profileImageUrl
//       ? student.profileImageUrl
//       : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//   }));


//       // ✅ If no students are fetched, set sample data for visualization
//       if (updatedStudents.length === 0) {
//         setStudents(sampleStudents);
//       } else {
//         setStudents(updatedStudents);
//       }
//     } catch (error) {
//       console.error("Error fetching students", error);
//       setStudents(sampleStudents); // Use sample data when an error occurs
//     }
//   };

//   const handleSearch = () => {
//     let filteredStudents = students;

//     if (searchName) {
//       filteredStudents = filteredStudents.filter((student) =>
//         `${student.firstName} ${student.lastName}`
//           .toLowerCase()
//           .includes(searchName.toLowerCase())
//       );
//     }

//     if (searchYear) {
//       filteredStudents = filteredStudents.filter(
//         (student) => student.graduationYear === searchYear
//       );
//     }

//     setStudents(filteredStudents);
//   };

//   // ✅ Sample Data (Only Used When API Fails)
//   const sampleStudents = [
//     {
//       _id: "1",
//       firstName: "John",
//       lastName: "Doe",
//       jobTitle: "Software Engineer",
//       company: "Google",
//       degree: "B.Tech CSE",
//       location: "New York",
//       graduationYear: "2025",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },
//     {
//       _id: "2",
//       firstName: "Alice",
//       lastName: "Smith",
//       jobTitle: "Product Manager",
//       company: "Amazon",
//       degree: "BBA",
//       location: "California",
//       graduationYear: "2024",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },
//     {
//       _id: "3",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },

//     {
//       _id: "4",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },

//     {
//       _id: "5",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },

//     {
//       _id: "6",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },

//     {
//       _id: "7",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },
//     {
//       _id: "8",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },
//     {
//       _id: "9",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },
//     {
//       _id: "10",
//       firstName: "Michael",
//       lastName: "Brown",
//       jobTitle: "UX Designer",
//       company: "Microsoft",
//       degree: "B.Des",
//       location: "Texas",
//       graduationYear: "2023",
//       profileImageUrl: "https://img-cdn.pixlr.com/image-generator/history/65bb506dcb310754719cf81f/ede935de-1138-4f66-8ed7-44bd16efc709/medium.webp",
//     },
//   ];

//   // ✅ Pagination Logic
//   const indexOfLastStudent = currentPage * studentsPerPage;
//   const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
//   const currentStudents = students.slice(indexOfFirstStudent, indexOfLastStudent);
//   const totalPages = Math.ceil(students.length / studentsPerPage);

//   return (
//     <div className="container">
//       {/* ✅ Top Left Heading */}
//       <div className="header">
//         {/* <h1>Students</h1> */}
//       </div>

//       {/* ✅ Centered Filters */}
//       <div className="filters">
//         <input
//           type="text"
//           placeholder="Search by Name"
//           value={searchName}
//           onChange={(e) => setSearchName(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by Location"
//           value={searchLocation}
//           onChange={(e) => setSearchLocation(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by Graduation Year"
//           value={searchYear}
//           onChange={(e) => setSearchYear(e.target.value)}
//         />
//         <button onClick={handleSearch}>Search</button>
//       </div>

//       {/* ✅ Student Cards in Center */}
//       <div className="cards-section">
//         <div className="card-container">
//           {currentStudents.length > 0
//             ? currentStudents.map((student, index) => (
//                 <div key={student._id} className="card">
//                   <p className="class-year"><b>Class of {student.graduationYear}</b></p>
//                   <img src={student.profileImageUrl} alt={student.firstName} />
//                   <div className="card-info">
//                     {/* <p className="class-year">Class of {student.graduationYear}</p> */}
//                     <h3>{student.firstName} {student.lastName}</h3>
//                     {student.jobTitle && <p><b>{student.jobTitle}, {student.company}</b></p>}
//                     <p>{student.degree}</p>
//                     <p>{student.location}</p>
//                     {/* <button>See More</button> */}
//                   </div>
//                 </div>
//               ))
//             : Array.from({ length: 9 }).map((_, index) => (
//                 <div key={index} className="card skeleton">
//                   <div className="skeleton-img"></div>
//                   <div className="skeleton-text"></div>
//                 </div>
//               ))}
//         </div>
//       </div>

//       {/* ✅ Bottom Center Pagination */}
//       <div className="pagination-section">
//         <div className="pagination">
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage(1)}>« First</button>
//           <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>‹ Prev</button>

//           {[...Array(totalPages)].map((_, i) => (
//             <button
//               key={i + 1}
//               className={currentPage === i + 1 ? "active" : ""}
//               onClick={() => setCurrentPage(i + 1)}
//             >
//               {i + 1}
//             </button>
//           ))}

//           <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Next ›</button>
//           <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)}>Last »</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StudentDash;
// -----------------------------------------------Earlier commented code even before the zip folder for static student cards addition is above this----------------------------------


// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import "./StudentDash.css"; // Ensure correct styling
// const StudentDash = () => {
//   const [students, setStudents] = useState([]);
//   const [searchName, setSearchName] = useState("");
//   const [searchworkEmail, setSearchworkEmail] = useState("");
//   const [searchYear, setSearchYear] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const studentsPerPage = 5;

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get("http://localhost:5080/api/students", {
//         headers: { "Content-Type": "application/json" },
//       });
//       const studentsData = response.data?.data || []; // Fallback in case of unexpected response
  
//       const updatedStudents = studentsData.map((student) => ({
//         ...student,
//         graduationYear: student.graduationYear || "N/A",
//         workEmail: student.workEmail || "N/A",
//         profileImageUrl: student.profileImageUrl
//           ? student.profileImageUrl
//           : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//       }));
  
//       setStudents(updatedStudents);
//     } catch (error) {
//       console.error("❌ Error fetching students:", error?.response?.data || error.message);
//       setStudents([]); // Ensure state doesn't break
//     }
//   };

  
//   const handleSearch = () => {
//     let filteredStudents = students;

//     if (searchName) {
//       filteredStudents = filteredStudents.filter((student) =>
//         `${student.firstName} ${student.lastName}`
//           .toLowerCase()
//           .includes(searchName.toLowerCase())
//       );
//     }

//     if (searchworkEmail) {
//       filteredStudents = filteredStudents.filter((student) =>
//         student.workEmail.toLowerCase().includes(searchworkEmail.toLowerCase())
//       );
//     }

//     if (searchYear) {
//       filteredStudents = filteredStudents.filter(
//         (student) => student.graduationYear === searchYear
//       );
//     }

//     setStudents(filteredStudents);
//   };

//   // Pagination logic
//   const indexOfLastStudent = currentPage * studentsPerPage;
//   const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
//   const currentStudents = students.slice(indexOfFirstStudent, indexOfLastStudent);

//   const nextPage = () => {
//     if (currentPage < Math.ceil(students.length / studentsPerPage)) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const prevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   return (
//     <div className="student-dashboard">
      

//       <div className="search-filters">
//         <input
//           type="text"
//           placeholder="Search by name..."
//           value={searchName}
//           onChange={(e) => setSearchName(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by email..."
//           value={searchworkEmail}
//           onChange={(e) => setSearchworkEmail(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by graduation year..."
//           value={searchYear}
//           onChange={(e) => setSearchYear(e.target.value)}
//         />
//         <button onClick={handleSearch}>Search</button>
//       </div>

//       <div className="student-list">
//         {currentStudents.length > 0 ? (
//           currentStudents.map((student, index) => (
//             <div key={index} className="student-card">
//                <p><strong>Class of {student.graduationYear}</strong></p>
//               <img src={student.profileImageUrl} alt="Profile" />
//               <h3>{`${student.firstName} ${student.lastName}` .replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
//               <p><strong>✉️</strong> {student.workEmail}</p> 
//             </div>
//           ))
//         ) : (
//           <p></p>
//         )}
//       </div>

//       <div className="pagination">
//         <button onClick={prevPage} disabled={currentPage === 1}>
//           Previous
//         </button>
//         <span>Page {currentPage}</span>
//         <button onClick={nextPage} disabled={indexOfLastStudent >= students.length}>
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default StudentDash;


// ---------------Commented the earlier working code which was deployed without the static student for the failed api fetch-------------------------------------------

// --------------------------------------Commenting this code which worked for static loading of cards-------------------------------------------------------------------------------------------------------
// import React, { useState /*, useEffect */ } from "react";
// // import axios from "axios";
// import "./StudentDash.css"; // Ensure correct styling
// const StudentDash = () => {
//   const [students, setStudents] = useState([
//     { _id: "1", firstName: "Meetangi", lastName: "Juneja", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Meetangi.jpeg" },
//     { _id: "2", firstName: "Geetali", lastName: "Kwatra", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Geetali.jpg" },
//     { _id: "3", firstName: "Paawan", lastName: "Nanda", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Paawan.jpeg" },
//     // { _id: "4", firstName: "Aryan", lastName: "Nair", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "/aryan-nair.jpg" },
//     // { _id: "5", firstName: "Pranav", lastName: "Bhatia", graduationYear: "2026", workEmail: "N/A", profileImageUrl: "/pranav-bhatia.jpg" },
//     // { _id: "6", firstName: "Aesha", lastName: "Singhal", graduationYear: "2026", workEmail: "N/A", profileImageUrl: "/aesha-singhal.jpg" },
//     // { _id: "7", firstName: "Gauri", lastName: "Srivastav", graduationYear: "2027", workEmail: "N/A", profileImageUrl: "/gauri-srivastav.jpg" },
//     // { _id: "8", firstName: "Tushita", lastName: "Mittal", graduationYear: "2027", workEmail: "N/A", profileImageUrl: "/tushita-mittal.jpg" },
//   ]);
//   const [searchName, setSearchName] = useState("");
//   const [searchworkEmail, setSearchworkEmail] = useState("");
//   const [searchYear, setSearchYear] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const studentsPerPage = 5;

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await axios.get("http://profile-card-service-arc.onrender.com/api/students", {
//         headers: { "Content-Type": "application/json" },
//       });
//       const studentsData = response.data?.data || []; // Fallback in case of unexpected response
  
//       const updatedStudents = studentsData.map((student) => ({
//         ...student,
//         graduationYear: student.graduationYear || "N/A",
//         workEmail: student.workEmail || "N/A",
//         profileImageUrl: student.profileImageUrl
//           ? student.profileImageUrl
//           : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
//       }));
  
//       setStudents(updatedStudents);
//     } catch (error) {
//       console.error("❌ Error fetching students:", error?.response?.data || error.message);

//   // Currently only the fallback for the static ones work will uncomment the usestate and the fetchusers when the backend is properly setup to connect and fetch cards
//   //     // Fallback to static data when backend fails

//   //     const sampleStudents = [
//   //       { _id: "1", firstName: "Meetangi", lastName: "Juneja", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Meetangi.jpeg" },
//   //       { _id: "2", firstName: "Geetali", lastName: "Kwatra", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Geetali.jpg" },
//   //       { _id: "3", firstName: "Paawan", lastName: "Nanda", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Paawan.jpeg" },
//   //       // { _id: "4", firstName: "Aryan", lastName: "Nair", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "/aryan-nair.jpg" },
//   //       // { _id: "5", firstName: "Pranav", lastName: "Bhatia", graduationYear: "2026", workEmail: "N/A", profileImageUrl: "/pranav-bhatia.jpg" },
//   //       // { _id: "6", firstName: "Aesha", lastName: "Singhal", graduationYear: "2026", workEmail: "N/A", profileImageUrl: "/aesha-singhal.jpg" },
//   //       // { _id: "7", firstName: "Gauri", lastName: "Srivastav", graduationYear: "2027", workEmail: "N/A", profileImageUrl: "/gauri-srivastav.jpg" },
//   //       // { _id: "8", firstName: "Tushita", lastName: "Mittal", graduationYear: "2027", workEmail: "N/A", profileImageUrl: "/tushita-mittal.jpg" },
//   //     ];
//   //     setStudents(sampleStudents); // Use static data on error
//     }
//   };

  
//   const handleSearch = () => {
//     let filteredStudents = students;

//     if (searchName) {
//       filteredStudents = filteredStudents.filter((student) =>
//         `${student.firstName} ${student.lastName}`
//           .toLowerCase()
//           .includes(searchName.toLowerCase())
//       );
//     }

//     if (searchworkEmail) {
//       filteredStudents = filteredStudents.filter((student) =>
//         student.workEmail.toLowerCase().includes(searchworkEmail.toLowerCase())
//       );
//     }

//     if (searchYear) {
//       filteredStudents = filteredStudents.filter(
//         (student) => student.graduationYear === searchYear
//       );
//     }

//     setStudents(filteredStudents);
//   };

//   // Pagination logic
//   const indexOfLastStudent = currentPage * studentsPerPage;
//   const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
//   const currentStudents = students.slice(indexOfFirstStudent, indexOfLastStudent);

//   const nextPage = () => {
//     if (currentPage < Math.ceil(students.length / studentsPerPage)) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const prevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   return (
//     <div className="student-dashboard">
      

//       <div className="search-filters">
//         <input
//           type="text"
//           placeholder="Search by name..."
//           value={searchName}
//           onChange={(e) => setSearchName(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by email..."
//           value={searchworkEmail}
//           onChange={(e) => setSearchworkEmail(e.target.value)}
//         />
//         <input
//           type="text"
//           placeholder="Search by graduation year..."
//           value={searchYear}
//           onChange={(e) => setSearchYear(e.target.value)}
//         />
//         <button onClick={handleSearch}>Search</button>
//       </div>

//       <div className="student-list">
//         {currentStudents.length > 0 ? (
//           currentStudents.map((student, index) => (
//             <div key={index} className="student-card">
//                <p><strong>Class of {student.graduationYear}</strong></p>
//               <img src={student.profileImageUrl} alt="Profile" />
//               <h3>{`${student.firstName} ${student.lastName}`.replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
//               <p><strong>✉️</strong> {student.workEmail}</p> 
//             </div>
//           ))
//         ) : (
//           <p></p>
//         )}
//       </div>

//       <div className="pagination">
//         <button onClick={prevPage} disabled={currentPage === 1}>
//           Previous
//         </button>
//         <span>Page {currentPage}</span>
//         <button onClick={nextPage} disabled={indexOfLastStudent >= students.length}>
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default StudentDash;

// -----------------------------------------------------------------------------------comment ends here----------------------------------------------------------------------------------------------------------




import React, { useState, useEffect } from "react";
import axios from "axios";
import "./StudentDash.css"; // Ensure correct styling

const StudentDash = () => {
  const [students, setStudents] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [searchworkEmail, setSearchworkEmail] = useState("");
  const [searchYear, setSearchYear] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const studentsPerPage = 6;

  // Static fallback data
  const sampleStudents = [
    { _id: "1", firstName: "Meetangi", lastName: "Juneja", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Meetangi.jpeg" },
    { _id: "2", firstName: "Geetali", lastName: "Kwatra", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Geetali.jpg" },
    { _id: "3", firstName: "Paawan", lastName: "Nanda", graduationYear: "2025", workEmail: "N/A", profileImageUrl: "../../staticstudent/Paawan.jpeg" },
  ];

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("https://profile-card-service.onrender.com/api/students", {
        headers: { "Content-Type": "application/json" },
      });
      const studentsData = response.data?.data || [];

      // Process API data
      const updatedStudents = studentsData.map((student) => ({
        ...student,
        graduationYear: student.graduationYear || "N/A",
        workEmail: student.workEmail || "N/A",
        profileImageUrl: student.profileImageUrl
          ? student.profileImageUrl
          : "https://res.cloudinary.com/dtliv3iee/image/upload/v1700000000/default-avatar.png",
      }));

      // If no valid data from API, use static data
      if (updatedStudents.length === 0) {
        setStudents(sampleStudents);
      } else {
        setStudents(updatedStudents);
      }
    } catch (error) {
      console.error("❌ Error fetching students:", error?.response?.data || error.message);
      // Fallback to static data on error
      setStudents(sampleStudents);
    }
  };

  const handleSearch = () => {
    let filteredStudents = students;

    if (searchName) {
      filteredStudents = filteredStudents.filter((student) =>
        `${student.firstName} ${student.lastName}`
          .toLowerCase()
          .includes(searchName.toLowerCase())
      );
    }

    if (searchworkEmail) {
      filteredStudents = filteredStudents.filter((student) =>
        student.workEmail.toLowerCase().includes(searchworkEmail.toLowerCase())
      );
    }

    if (searchYear) {
      filteredStudents = filteredStudents.filter(
        (student) => student.graduationYear === searchYear
      );
    }

    setStudents(filteredStudents);
  };

  // Pagination logic
  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = students.slice(indexOfFirstStudent, indexOfLastStudent);

  const nextPage = () => {
    if (currentPage < Math.ceil(students.length / studentsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="student-dashboard">
      <div className="search-filters">
        <input
          type="text"
          placeholder="Search by name..."
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Search by email..."
          value={searchworkEmail}
          onChange={(e) => setSearchworkEmail(e.target.value)}
        />
        <input
          type="text"
          placeholder="Search by graduation year..."
          value={searchYear}
          onChange={(e) => setSearchYear(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      <div className="student-list">
        {currentStudents.length > 0 ? (
          currentStudents.map((student, index) => (
            <div key={index} className="student-card">
              <p><strong>Class of {student.graduationYear}</strong></p>
              <img src={student.profileImageUrl} alt="Profile" />
              <h3>{`${student.firstName} ${student.lastName}`.replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
              <p><strong>✉️</strong> {student.workEmail}</p>
            </div>
          ))
        ) : (
          <p>No students found</p>
        )}
      </div>

      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button onClick={nextPage} disabled={indexOfLastStudent >= students.length}>
          Next
        </button>
      </div>
    </div>
  );
};

export default StudentDash;
